export const NAME = 'discount';

export const REQUEST_PARTNER_DISCOUNTS = 'REQUEST_PARTNER_DISCOUNTS';
export const RECEIVE_PARTNER_DISCOUNTS = 'RECEIVE_PARTNER_DISCOUNTS';
export const FAILURE_PARTNER_DISCOUNTS = 'FAILURE_PARTNER_DISCOUNTS';

export const REQUEST_PARTNER_MOST_DISPLAYABLE_DISCOUNT =
    'REQUEST_PARTNER_MOST_DISPLAYABLE_DISCOUNT';
export const RECEIVE_PARTNER_MOST_DISPLAYABLE_DISCOUNT =
    'RECEIVE_PARTNER_MOST_DISPLAYABLE_DISCOUNT';
export const FAILURE_PARTNER_MOST_DISPLAYABLE_DISCOUNT =
    'FAILURE_PARTNER_MOST_DISPLAYABLE_DISCOUNT';



// WEBPACK FOOTER //
// ./src/services/discount/constants.js